import { Component } from '@angular/core';
import { task_management_access_modules } from '../../shared/constants';

@Component({
	selector: 'app-access-modules',
	templateUrl: './access-modules.component.html',
	styleUrl: './access-modules.component.scss'
})
export class AccessModulesComponent {
	task_management_access_modules = JSON.parse(JSON.stringify(task_management_access_modules));

	public getAccessObj() {
		let access: any = {};
		for (let i = 0; i < this.task_management_access_modules.length; i++) {
			for (let j = 0; j < this.task_management_access_modules[i].access.length; j++) {
				access[this.task_management_access_modules[i].access[j].key] = this.task_management_access_modules[i].access[j].value || false;
			}
		}
		return access;
	}

	public setAccess(access: any) {
		if (access) {
			for (let i = 0; i < this.task_management_access_modules.length; i++) {
				for (let j = 0; j < this.task_management_access_modules[i].access.length; j++) {
					this.task_management_access_modules[i].access[j].value = access[this.task_management_access_modules[i].access[j].key] || false;
				}
			}
		}
	}
}
